<!--
대금상환 창고지급 정정 팝업 (TASK-161 §0-9 — 라운드 ⓒ · 라벨 결정 30 · 날짜 결정 28)
------------------------------------
 - 페이지당 1 인스턴스. 행 「정정」 버튼이 open(row) 로 데이터 주입
 - 창고지급(실제) · 창고지급일 · 창고지급비고 현재값 프리필
 - 사이클 14 #13: 소속 상품 카드 (공용 app-buy-order-prod-cards readonly — row.prods, .cdp-popup-prod-card)
 - 사이클 16 #27: 상단 = 공용 컨텍스트 헤더 app-buy-order-ctx (대금상환금액 큰 글자 · 창고지급(실제)) · 상품 = 간략 행
 - 창고지급일 = flatpickr (Y-m-d, 직접 입력 가능 — date-input.js)
 - 저장 → PATCH /regions/{regionId}/cod-payments/{id}
   창고지급비고는 서버가 null 도 덮어쓰므로 현재 값을 항상 전송한다 (결정 8-F3)
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-correct-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">창고지급 정정</h3>

            <!-- 사이클 16 #27 — 컨텍스트 헤더 (공용 app-buy-order-ctx: 해외오더번호 · 트래킹 칩 · 대금상환금액 큰 글자 · 창고지급(실제)) -->
            <app-buy-order-ctx v-if="row" :code="row.buy_order_code || ''" :trackings="row.tracking_nos || []"
                               :items="[{k: '대금상환금액', v: reqAmountText, big: true}, {k: '창고지급(실제)', v: paidAmountText}]"></app-buy-order-ctx>

            <!-- 사이클 14 #13 → 16 #27 — 소속 상품 간략 행 (창고지급 팝업과 동일 — 금액을 다루는 창) -->
            <div class="uk-margin-small cdp-popup-prods" v-if="row && row.prods">
                <div class="uk-text-muted cdp-popup-prods__hd">소속 상품 {{ row.prods.length }}건</div>
                <div class="cdp-popup-prods__wrap">
                    <app-buy-order-prod-cards :prods="row.prods" readonly card-class="cdp-popup-prod-card"></app-buy-order-prod-cards>
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">창고지급(실제) <span v-if="row && row.currency">({{ row.currency }})</span></label>
                <div class="uk-form-controls">
                    <input class="uk-input cdp-correct-amount" type="text" v-model.trim="inputPaidAmount" placeholder="창고지급(실제)"/>
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">창고지급일</label>
                <div class="uk-form-controls">
                    <input ref="paidAt" class="uk-input cdp-correct-at" type="text" v-model="inputPaidAt" placeholder="e.g. 2025-01-01"/>
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">창고지급비고</label>
                <div class="uk-form-controls">
                    <textarea class="uk-textarea cdp-correct-memo" rows="3" v-model="inputPaidMemo" placeholder="창고지급비고"></textarea>
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary cdp-correct-submit" type="button" :disabled="busy" @click="submit">저장</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from './popup-mixin';
    import { bindDateInput, setDateInput, destroyDateInput } from './date-input';

    export default {
        mixins: [CodPopupMixin],
        props: {
            // csrf-token
            csrfToken: String,

            // 센터ID (라우트)
            regionId: [String, Number],
        },
        data: function () {
            return {
                inputPaidAmount: '',
                inputPaidAt: '',
                inputPaidMemo: '',
            };
        },
        created() {
            // flatpickr instance (비반응)
            this.paidAtPicker = null;
        },
        mounted() {
            // 결정 28 — 날짜 포맷 Y-m-d (flatpickr)
            this.paidAtPicker = bindDateInput(this.$refs.paidAt, (value) => {
                this.inputPaidAt = value;
            });
        },
        beforeDestroy() {
            destroyDateInput(this.paidAtPicker);
            this.paidAtPicker = null;
        },
        methods: {
            open(row) {
                this.row = row || null;
                this.inputPaidAmount = row ? this.normalize(row.paid_amount) : '';
                this.inputPaidAt = row ? this.normalize(row.paid_at) : '';
                setDateInput(this.paidAtPicker, this.inputPaidAt);
                this.inputPaidMemo = row ? this.normalize(row.paid_memo) : '';
                this.show();
            },

            submit() {
                if (this.busy || ! this.row) {
                    return;
                }
                this.request('patch', '/regions/' + this.regionId + '/cod-payments/' + this.row.id, {
                    paid_amount: this.inputPaidAmount,
                    paid_at: this.inputPaidAt,
                    // 현재 값 항상 전송 (결정 8-F3)
                    paid_memo: this.inputPaidMemo,
                }).then(this.done);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 소속 상품 (사이클 14 #13 → 16 #27 — paid-popup 과 동일, 스크롤 = 공용 목록 안)
    .cdp-popup-prods__hd {
        margin-bottom: 4px;
    }
</style>
